<template>
  <div>
    <template v-if="loading">
      <v-row justify="center" align-content="center" class="mt-10">
        <img src="../../assets/loading.gif">
      </v-row>
    </template>
    <template v-else>
      <v-row class="grey lighten-3" style="height: 1080px">
        <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
          <!-- <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a> -->
        </v-col>
        <v-col md="8" style="background-color: #FFFFFF; position: relative;" class="text-center">
          <v-row class="signup-form overflow-hidden text-center">
            <p v-if="page" style="color: #9E9EA7;" class="text-center font-weight-black">承認しました。</p>
            <p v-else style="color: #9E9EA7;" class="">URLが無効です。操作をやり直してください。</p>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </div>
</template>
<script>
export default {
  name: 'TopicPermissionApproval',
  data() {
    return {
      page: null,
      height: window.innerHeight,
      loading: true,
    }
  },
  beforeCreate: function () {
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/topic_permission/' + this.$route.params.token)
    .then(() => {
      this.page = true
    })
    .catch(() => {
      this.page = false
    })
    .finally(() => this.loading = false)
    
  },
}
</script>
